import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { HttpClient } from "@angular/common/http";
import { HttpService } from "../../../services/http/http.service";
import { LoginService } from "./login-form.service";
import { Router, ActivatedRoute } from "@angular/router";
import { Store } from "@ngrx/store";
import { NgModule } from "@angular/core";
import Swal from "sweetalert2";
import { HttpErrorResponse } from "@angular/common/http";
import { Location } from "@angular/common";
import { SocialAuthService } from "angularx-social-login";
import {
  FacebookLoginProvider,
  GoogleLoginProvider,
} from "angularx-social-login";
import { SocialUser } from "angularx-social-login";
import swal from "sweetalert2";
import { identity, interval } from "rxjs";
@Component({
  selector: "login-form",
  templateUrl: "./login-form.component.html",
  styleUrls: ["./login-form.component.scss"],
})
export class LoginFormComponent implements OnInit {
  loginForm: FormGroup;
  loadingLoginForm: boolean;
  errorMessage;
  encodedURL: string;
  validtoken: any;
  validtokenquiz: string;
  constructor(
    private authService: SocialAuthService,
    private fb: FormBuilder,
    private httpS: HttpService,
    private loginService: LoginService,
    private router: Router,
    private _location: Location,
    private route: ActivatedRoute
  ) {}
  email: any;
  name: any;
  user_group: any;
  user: SocialUser;
  loggedIn: boolean;
  ids;
  userType;
  diestPrefArray;
  allergenceArray;
  allergenceArrayName;
  diestPrefArrayName;
  apicrossContamination;
  ac;
  tableids;
  allAllergDatas;
  restoID;
  tableID;
  allDietDatas;
  dishesAlldata;
  dishes;
  orderItem = [];
  orderDishes;
  orderToken;
  UserCondition;
  userCC;
  quiz_id: any;
  spice_rating_all;
  encodedtokenquiz;

  ngOnInit() {
    this.ids = sessionStorage.getItem("restoIds");
    this.tableids = sessionStorage.getItem("tableIds");
    this.restoID = sessionStorage.getItem("restoId");
    this.tableID = sessionStorage.getItem("tableId");
    // sessionStorage.removeItem('restoIds');
    // sessionStorage.removeItem('tableIds');
    // sessionStorage.removeItem('restoId');
    // sessionStorage.removeItem('tableId');
    const dataAlleregy = sessionStorage.getItem("selectedAlleregence");
    this.allAllergDatas = JSON.parse("[" + dataAlleregy + "]");
    const dataDiet = sessionStorage.getItem("selectedDiestpref");
    this.allDietDatas = JSON.parse("[" + dataDiet + "]");
    this.route.queryParams.subscribe((params) => {
      this.quiz_id = params["identity"];
      if (this.quiz_id) {
        sessionStorage.clear();
        sessionStorage.setItem("quiz_identity", this.quiz_id);
        this.encodedURL = encodeURIComponent(this.quiz_id);
      }
    });

    this.route.queryParams.subscribe((params) => {
      this.validtokenquiz = params["valididentity"];
      if (this.validtokenquiz) {
        this.validtoken = atob(this.validtokenquiz);
        sessionStorage.setItem("access_token", this.validtoken);
        this.validAuthToken();
        this.getPreferencereference();
      }
    });

    this.authService.authState.subscribe((user) => {
      this.user = user;
      this.loggedIn = user != null;
    });

    this.loginForm = this.fb.group({
      login: ["", Validators.required],
      pass: ["", Validators.required],
    });

    this.dishesAlldata = sessionStorage.getItem("orders-data");
    this.dishes = JSON.parse(this.dishesAlldata);
    for (let i = 0; i < this.dishes; i++) {
      let temp = {
        dish_id: this.dishes[i].food_dish_id,
        dish_quantity: this.dishes[i].quantity,
        dish_spice_rating: this.dishes[i].spice_rating,
      };
      this.orderItem.push(temp);
    }
    this.UserCondition = sessionStorage.getItem("access_token") ? true : false;
    if (this.UserCondition) {
      this.getUserPreference();
    }
  }
  backClicked() {
    this.router.navigate(["public/resto"], {
      queryParams: { id: this.ids, table_id: this.tableids },
    });
  }

  tasteDetailsput() {
    this.httpS.tasteDetailsput(this.encodedURL).subscribe(
      (res) => {
        if (res["status"] == true) {
          if (res["result"].data == true) {
            this.router.navigate(["/horizontal/userprofile"]);
          }
        }
      },
      (err: HttpErrorResponse) => {
        this.errorMessage = err.error.message;
        this.logout();
        if (err.status == 401) {
          this.logout();
        } else if (err.status == 500) {
          this.logout();
        }
      }
    );
  }
  getUserPreference() {
    this.httpS.getUserPreference().subscribe(
      (response) => {
        if (response["status"] == true) {
          this.userCC = response["result"].data.cross_contamination;
          sessionStorage.setItem("UserCC", this.userCC);
        }
      },
      (err: HttpErrorResponse) => {
        this.errorMessage = err.error.message;
        if (err.status == 401) {
          this.logout();
        } else if (err.status == 500) {
          this.logout();
        } else if (err.status == 422) {
          sessionStorage.setItem("UserCC", "No");
        }
      }
    );
  }
  signInWithGoogle(): void {
    this.authService
      .signIn(GoogleLoginProvider.PROVIDER_ID)
      .then((userData) => {
        // console.log("Googledata", userData)
        const datas = {
          email: userData["email"],
          name: userData["name"],
          source: "Google",
        };
        this.loginService.postLoginSocial(datas).subscribe(
          (response) => {
            console.log("response", response);
            // if (response['status'] == true) {
            //   const data = {
            //     accessToken: response.result.authToken,
            //     restoID: response.result.userDetails.restaurant_id,

            //   };
            //   sessionStorage.setItem('access_token', data.accessToken);
            //   sessionStorage.setItem('restoID', data.restoID);
            //   sessionStorage.setItem('userName', response.result.userDetails.userName);
            //   sessionStorage.setItem('currentUser', JSON.stringify(data));
            //   this.userType = response.result.userDetails.userType
            //   if (this.userType == "users") {
            //     this.httpS.getUserPreference().subscribe(res => {
            //       if (res['status'] == true) {
            //         let showMenuClicked = sessionStorage.getItem("isGuestShowMenuClicked");
            //         if (showMenuClicked) {
            //           this.userPreferenceChange();

            //         } else {
            //           this.getPreferencereference();
            //         }

            //       }

            //     }, err => {
            //       this.router.navigate(['/horizontal/choose-preference']);
            //     })

            //   }
            //   else {
            //     Swal.fire("User does not exists");
            //   }
            // }
          },
          (err: HttpErrorResponse) => {
            console.log("get configuration error", err);
          }
        );
      });
  }

  // signInWithFB(): void {
  //   sessionStorage.removeItem('access_token');
  //   sessionStorage.removeItem('currentUser');
  //   this.authService.signIn(FacebookLoginProvider.PROVIDER_ID).then((userData) => {
  //     // console.log("fbuserdata", userData)
  //     const data = {
  //       email: userData['email'],
  //       name: userData['name'],
  //       source: "Facebook"
  //     }
  //     this.loginService.postLoginSocial(data).subscribe(response => {
  //       if (response['status'] == true) {
  //         const data = {
  //           accessToken: response.result.authToken,
  //           restoID: response.result.userDetails.restaurant_id,
  //         };
  //         sessionStorage.setItem('access_token', data.accessToken);
  //         sessionStorage.setItem('restoID', data.restoID);
  //         sessionStorage.setItem('userName', response.result.userDetails.userName);
  //         sessionStorage.setItem('currentUser', JSON.stringify(data));
  //         this.userType = response.result.userDetails.userType
  //         if (this.userType == "users") {
  //           this.httpS.getUserPreference().subscribe(res => {
  //             if (res['status'] == true) {
  //               let showMenuClicked = sessionStorage.getItem("isGuestShowMenuClicked");
  //               if (showMenuClicked) {
  //                 this.userPreferenceChange();

  //               } else {
  //                 this.getPreferencereference();
  //               }
  //             }

  //           }, err => {
  //             this.router.navigate(['/horizontal/choose-preference']);
  //           })
  //         }
  //         else {
  //           Swal.fire("Your Not allow to Login");
  //         }

  //       }
  //       else {
  //         Swal.fire("Something Went Wrong")
  //       }
  //     },
  //       (err: HttpErrorResponse) => {
  //         this.errorMessage = err.error['data'].message;
  //       });
  //   });
  // }

  signOut(): void {
    this.authService.signOut();
  }
  loginFormSubmit() {
    let showMenuClicked = sessionStorage.getItem("isGuestShowMenuClicked");

    this.loadingLoginForm = true;
    if (this.loginForm.invalid) {
      return;
    }

    this.loginService.postLogin(this.loginForm.value).subscribe(
      (response) => {
        if (response["status"] == true) {
          const data = {
            accessToken: response.result.authToken,
            restoID: response.result.userDetails.restaurant_id,
            userName: response.result.userDetails.userName,
          };
          sessionStorage.setItem("access_token", data.accessToken);
          // sessionStorage.setItem('restoID', data.restoID);
          sessionStorage.setItem("userName", data.userName);
          sessionStorage.setItem("currentUser", JSON.stringify(data));
          let showMenuClicked = sessionStorage.getItem("isGuestShowMenuClicked");

          // this.tasteDetails();
          if (showMenuClicked) {
            this.userPreferenceChange();
          } else {
            this.getPreferencereference();
          }
        } else {
          Swal.fire("Something Went Wrong");
        }
      },
      (err: HttpErrorResponse) => {
        this.errorMessage = err.error["data"].message;
        swal.fire(this.errorMessage);
      }
    );
  }

  getPreferencereference() {
    this.httpS.getUserPreference().subscribe(
      (res) => {
        if (res["status"] == true) {
          if (
            res["result"].data.allergens.length ||
            res["result"].data.dietary.length
          ) {
            if (
              res["result"].data.allergens &&
              res["result"].data.allergens.length
            ) {
              this.allergenceArray = res["result"].data.allergens;
              console.log(this.allergenceArray);
              this.spice_rating_all = res["result"].data.spice_rating_all;
              sessionStorage.setItem("spiceRating", this.spice_rating_all);
              sessionStorage.setItem(
                "selectedAlleregence",
                this.allergenceArray.toString()
              );
              this.allergenceArrayName = res["result"].data.allergens_name;
              sessionStorage.setItem(
                "allergenceArrayName",
                this.allergenceArrayName.toString()
              );
            }
            if (
              res["result"].data.dietary &&
              res["result"].data.dietary.length
            ) {
              this.diestPrefArray = res["result"].data.dietary;
              sessionStorage.setItem(
                "selectedDiestpref",
                this.diestPrefArray.toString()
              );
              this.diestPrefArrayName = res["result"].data.dietary_name;
              sessionStorage.setItem(
                "diestPrefArrayName",
                this.diestPrefArrayName.toString()
              );
            }
            this.router.navigate(["horizontal/food-menu"]);
          } else {
            if (this.quiz_id) {
              this.tasteDetailsput();
              this.router.navigate(["/horizontal/userprofile"]);
            } else if (this.validtoken) {
              if (this.restoID) {
                this.router.navigate(["/horizontal/profile"]);
              } else {
                this.router.navigate(["/horizontal/userprofile"]);
              }
            } else {
              this.router.navigate(["/horizontal/choose-preference"]);
            }
          }
        }
      },
      (err) => {
        this.router.navigate(["/horizontal/choose-preference"]);
      }
    );
  }

  userPreferenceChange() {
    this.getUserPreference();
    let apiAllergns = [];
    let apiDietery = [];
    const allrgArray = JSON.parse(
      "[" + sessionStorage.getItem("selectedAlleregence") + "]"
    );
    const dietArray = JSON.parse(
      "[" + sessionStorage.getItem("diestPrefArray") + "]"
    );
    const popallrgArray = sessionStorage.getItem("selectedAlleregence");
    const popdietArray = sessionStorage.getItem("diestPrefArray");
    this.httpS.getUserPreference().subscribe((res) => {
      apiAllergns = res["result"].data.allergens;
      apiDietery = res["result"].data.dietary;
      this.apicrossContamination = sessionStorage.getItem("UserCC");
      this.diestPrefArrayName = res["result"].data.dietary_name;
      this.allergenceArrayName = res["result"].data.allergens_name;
      if (
        apiAllergns.toString() == allrgArray.toString() &&
        apiDietery.toString() == dietArray.toString()
      ) {
        let showMenuClicked = sessionStorage.getItem("isGuestShowMenuClicked");
        let showprofile = sessionStorage.getItem("guestTouserProfile");
        let showorders = sessionStorage.getItem("guestToOrders");
        if (showMenuClicked == "true" && showprofile == "true") {
          this.router.navigate(["/horizontal/profile"]);
        } else if (showMenuClicked == "true" && showorders == "true") {
          this.router.navigate(["/horizontal/order-list"]);
        } else {
          this.router.navigate(["/horizontal/choose-preferences"]);
        }
      } else if (
        res["result"].data.allergens.toString() != allrgArray.toString() ||
        res["result"].data.dietary.toString() != dietArray.toString()
      ) {
        let showMenuClicked = sessionStorage.getItem("isGuestShowMenuClicked");

        const swalWithBootstrapButtons = Swal.mixin({
          customClass: {
            confirmButton: "btn btn-success",
            cancelButton: "btn btn-danger",
          },
          buttonsStyling: false,
        });

        swalWithBootstrapButtons
          .fire({
            title: "Are you sure?",
            text: "You want to update the preferences!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes",
            cancelButtonText: "No",
            reverseButtons: true,
          })
          .then((result) => {
            if (result.isConfirmed) {
              let showMenuClicked = sessionStorage.getItem(
                "isGuestShowMenuClicked"
              );
              let showprofile = sessionStorage.getItem("guestTouserProfile");
              let showorders = sessionStorage.getItem("guestToOrders");
              // let dataAllrArray = apiAllergns.concat(allrgArray).filter((v,i,s) => s.indexOf(v)== i);
              // console.log("data",dataAllrArray);
              // let dataDietaryArray = apiDietery.concat(dietArray).filter((v,i,s) => s.indexOf(v)== i);
              // console.log("dietarydata",dataDietaryArray);
              // sessionStorage.setItem("selectedAlleregence",dataAllrArray.toString());
              // sessionStorage.setItem("diestPrefArray",dataDietaryArray.toString())
              // sessionStorage.setItem("isGuestShowMenuClicked","true")
              // sessionStorage.setItem("allergenceArrayName",this.allergenceArrayName.toString())
              // console.log("array",allrgArray);
              // console.log("dietary",dietArray)
              this.getUserPreference();
              if (allrgArray.length != 0 || dietArray.length != 0) {
                sessionStorage.setItem("selectedAlleregence", allrgArray);
                sessionStorage.setItem("diestPrefArray", dietArray);
                const data = {
                  allergens: allrgArray,
                  dietary: dietArray,
                  spice_rating_all: sessionStorage.getItem("spiceRating"),
                  cross_contamination: sessionStorage.getItem("UserCC"),
                };

                this.httpS.postUserPreference(data).subscribe(
                  (res) => {
                    if (res["status"] == true) {
                      if (showMenuClicked == "true" && showprofile == "true") {
                        this.router.navigate(["/horizontal/profile"]);
                      } else if (
                        showMenuClicked == "true" &&
                        showorders == "true"
                      ) {
                        this.router.navigate(["/horizontal/order-list"]);
                      }
                    }
                  },
                  (err) => {}
                );
              } else if (allrgArray.length == 0 && dietArray.length == 0) {
                sessionStorage.setItem("selectedAlleregence", allrgArray);
                sessionStorage.setItem("diestPrefArray", dietArray);
                const data = {
                  allergens: [],
                  dietary: [],
                  spice_rating_all: sessionStorage.getItem("spiceRating"),
                  cross_contamination: sessionStorage.getItem("UserCC"),
                };

                this.httpS.postUserPreference(data).subscribe(
                  (res) => {
                    if (res["status"] == true) {
                      if (showMenuClicked == "true" && showprofile == "true") {
                        this.router.navigate(["/horizontal/profile"]);
                      } else if (
                        showMenuClicked == "true" &&
                        showorders == "true"
                      ) {
                        this.router.navigate(["/horizontal/order-list"]);
                      }

                      // else if(){
                      //   this.router.navigate(['/horizontal/order-list']);
                      // }
                      // else{
                      //  this.router.navigate(['/horizontal/choose-preferences']);
                      // }
                    }
                  },
                  (err) => {
                    //  alert("fail");
                  }
                );
              }
            } else if (
              /* Read more about handling dismissals below */
              result.dismiss === Swal.DismissReason.cancel
            ) {
              this.customlogout();
            }
          });
      }
    });
  }

  customlogout() {
    sessionStorage.removeItem("access_token");
    this.router.navigate(["public/guest-user"]);
  }

  validAuthToken() {
    this.httpS.validAuthToken().subscribe(
      (res) => {
        if (res["status"] == true) {
        }
      },
      (err: HttpErrorResponse) => {
        console.log(err);
      }
    );
  }

  logout() {
    let token = sessionStorage.getItem("access_token");
    this.httpS.logouts(token).subscribe((response) => {
      if (response["status"] == true) {
        this.router.navigate(["public/resto"], {
          queryParams: { id: this.ids, table_id: this.tableids },
        });
        sessionStorage.clear();
      } else {
        Swal.fire("Something Went Wrong");
      }
    });
  }
}
